// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__12C7w","left":"StickyBox_left__1psly","right":"StickyBox_right__e7dvh"};